<div class="PaP-banner">
  <div class="header">
    <img alt="" width="64" height="51" class="megaphone" src="/icons/megaphone.svg">
    <div class="col-10">
      <p> {{ "mfa.banner.header" | cxTranslate }} </p>
    </div>
    <button type="button" class="close" aria-label="Close" (click)="closeBanner()">
      <img alt="" width="20" height="20" src="/icons/{{baseSiteId}}/close.svg">
    </button>
  </div>
  <div class="col-12 message">
    <p class="mb-0"> {{ "mfa.banner.message" | cxTranslate }} </p>
  </div>
</div>
